import { defineComponent, ref, watch, onMounted } from 'vue';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';
import { Bar } from 'vue-chartjs';
// Registrar los componentes de Chart.js
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);
export default defineComponent({
    name: 'SalesChart',
    components: {
        Bar,
    },
    props: {
        chartType: {
            type: String,
            required: true,
        }
    },
    setup(props) {
        const selectedFilter = ref('7d');
        const startDate = ref('');
        const endDate = ref('');
        const chartData = ref({
            labels: [],
            datasets: [
                {
                    label: props.chartType === 'orders' ? 'Órdenes Mensuales' : 'Ingresos Mensuales',
                    backgroundColor: '#4F46E5',
                    borderColor: '#3B82F6',
                    borderWidth: 2,
                    data: [],
                },
            ],
        });
        const chartOptions = ref({
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                x: {
                    grid: {
                        display: false,
                    },
                    ticks: {
                        color: '#6B7280',
                        font: {
                            size: 14,
                        },
                    },
                },
                y: {
                    grid: {
                        color: '#e5e7eb',
                        borderColor: '#d1d5db',
                    },
                    ticks: {
                        color: '#6B7280',
                        font: {
                            size: 14,
                        },
                        callback: (value) => props.chartType === 'orders' ? `${value}` : `$${value}`,
                    },
                },
            },
            plugins: {
                legend: {
                    position: 'top',
                    labels: {
                        color: '#374151',
                        font: {
                            size: 16,
                        },
                    },
                },
                tooltip: {
                    backgroundColor: '#ffffff',
                    titleColor: '#000000',
                    bodyColor: '#4F46E5',
                    borderColor: '#d1d5db',
                    borderWidth: 1,
                },
            },
        });
        const updateChartData = (labels, data) => {
            chartData.value = {
                labels,
                datasets: [
                    {
                        label: props.chartType === 'orders' ? 'Órdenes Mensuales' : 'Ingresos Mensuales',
                        backgroundColor: '#4F46E5',
                        borderColor: '#3B82F6',
                        borderWidth: 2,
                        data,
                    },
                ],
            };
        };
        const applyFilter = async () => {
            let start;
            let end;
            switch (selectedFilter.value) {
                case '7d':
                    end = new Date();
                    start = new Date();
                    start.setDate(end.getDate() - 7);
                    break;
                case '30d':
                    end = new Date();
                    start = new Date();
                    start.setDate(end.getDate() - 30);
                    break;
                case '3m':
                    end = new Date();
                    start = new Date();
                    start.setMonth(end.getMonth() - 3);
                    break;
                case '6m':
                    end = new Date();
                    start = new Date();
                    start.setMonth(end.getMonth() - 6);
                    break;
                case '12m':
                    end = new Date();
                    start = new Date();
                    start.setMonth(end.getMonth() - 12);
                    break;
                case 'custom':
                    if (startDate.value && endDate.value) {
                        start = new Date(startDate.value);
                        end = new Date(endDate.value);
                    }
                    else {
                        // Si no hay fechas personalizadas, salir de la función
                        return;
                    }
                    break;
                default:
                    return;
            }
            const labels = getDatesInRange(start, end);
            const data = labels.map(() => Math.floor(Math.random() * 0) + 0); // Datos aleatorios para demostrar
            updateChartData(labels, data);
        };
        const getDatesInRange = (start, end) => {
            const dates = [];
            const current = new Date(start);
            while (current <= end) {
                dates.push(current.toLocaleDateString('es-ES'));
                current.setDate(current.getDate() + 1);
            }
            return dates;
        };
        watch(() => props.chartType, () => {
            applyFilter(); // Reaplicar el filtro cuando cambie el tipo de gráfico
        });
        onMounted(() => {
            applyFilter(); // Cargar datos iniciales para el filtro predeterminado
        });
        return {
            selectedFilter,
            startDate,
            endDate,
            chartData,
            chartOptions,
            applyFilter,
        };
    },
});
